module.exports = __webpack_public_path__ + "static/img/share-sine.f3402a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/share-sine.png
// module id = IPVU
// module chunks = 0